import React, { RefObject } from 'react';
import { Playlist } from '../types';

interface PlaylistSelectorProps {
  isPlaylistMenuOpen: boolean;
  playlists: Playlist[];
  currentPlaylist: Playlist | null;
  onPlaylistSelect: (playlist: Playlist) => void;
  menuRef: RefObject<HTMLDivElement>;
  isWalkthroughMode?: boolean; // Flag to bypass subscription checks during walkthrough
}

const PlaylistSelector: React.FC<PlaylistSelectorProps> = ({
  isPlaylistMenuOpen,
  playlists,
  currentPlaylist,
  onPlaylistSelect,
  menuRef,
  isWalkthroughMode = false
}) => {
  if (!isPlaylistMenuOpen) return null;
  
  return (
    <div className="playlist-bubbles" ref={menuRef}>
      {playlists.map((playlist) => (
        <div 
          key={playlist.id}
          className={`playlist-bubble ${currentPlaylist?.id === playlist.id ? 'active' : ''}`}
          onClick={(e) => {
            // Prevent the click from bubbling up to parent elements
            e.stopPropagation();
            onPlaylistSelect(playlist);
          }}
        >
          {playlist.name}
        </div>
      ))}
    </div>
  );
};

export default PlaylistSelector; 